import { gsap } from 'gsap';

const selectors = {
  credit: '[data-credit]',
  creditToggle: '[data-credit-toggle]',
}

class SiteFooter extends HTMLElement {
  #active = false;

  constructor() {
    super();

    this.handleCreditToggle = this.handleCreditToggle.bind(this);
  }

  handleCreditToggle(event) {
    event.preventDefault();
    event.stopPropagation();

    this.#active = !this.#active;

    this.credit.setAttribute('data-active', this.#active ? 'true' : 'false');
  }

  connectedCallback() {
    this.credit = this.querySelector(selectors.credit);
    this.creditToggle = this.querySelector(selectors.creditToggle);

    this.creditToggle.addEventListener('click', this.handleCreditToggle);
  }

  disconnectedCallback() {
    this.creditToggle.removeEventListener('click', this.handleCreditToggle);
  }
}

if (!customElements.get('site-footer')) {
  customElements.define('site-footer', SiteFooter);
}